webpackJsonp([14],{

/***/ 1119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BiosecurityForm_vue__ = __webpack_require__(1274);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b29e7f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BiosecurityForm_vue__ = __webpack_require__(1432);
function injectStyle (ssrContext) {
  __webpack_require__(1427)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b29e7f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BiosecurityForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b29e7f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BiosecurityForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__ = __webpack_require__(75);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FTextarea',
  components: {
    FGroup: __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__["a" /* default */]
  },
  props: {
    value: {
      default: ''
    },
    label: String,
    id: {
      type: String,
      required: true
    },
    rows: {
      default: 3
    },
    required: Boolean,
    placeholder: String,
    tooltip: String,
    error: {
      type: String,
      default: null
    }
  }
});

/***/ }),

/***/ 1133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FTextarea_vue__ = __webpack_require__(1128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dfa61c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FTextarea_vue__ = __webpack_require__(1134);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FTextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dfa61c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FTextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-group',{attrs:{"label":_vm.label,"id":_vm.id,"required":_vm.required,"tooltip":_vm.tooltip,"error":_vm.error}},[_c('textarea',{class:['form-control', _vm.error && 'is-invalid'],attrs:{"id":_vm.id,"rows":_vm.rows,"required":_vm.required,"placeholder":_vm.placeholder,"autocomplete":"off"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FRadioGroup',
  props: {
    name: {
      type: String,
      required: true
    },
    label: String,
    value: {
      default: null
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: Boolean,
    required: Boolean,
    inline: Boolean,
    error: {
      type: String,
      default: null
    }
  }
});

/***/ }),

/***/ 1147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useScrollToError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);

function useScrollToError(errors) {
  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(errors, function () {
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["f" /* nextTick */])(function () {
      var first = document.querySelector('.is-invalid');

      if (first) {
        first.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    });
  });
}

/***/ }),

/***/ 1169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FRadioGroup_vue__ = __webpack_require__(1143);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4df08032_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FRadioGroup_vue__ = __webpack_require__(1170);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FRadioGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4df08032_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FRadioGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.label)),(_vm.required)?_c('span',{staticClass:"text-danger ml-1"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{class:{ 'd-flex flex-wrap': _vm.inline }},_vm._l((_vm.options),function(option){return _c('div',{key:option.value,staticClass:"custom-control custom-radio",class:{ 'mr-4': _vm.inline }},[_c('input',{staticClass:"custom-control-input",attrs:{"id":(_vm.name + "_" + (option.value)),"type":"radio","name":_vm.name,"disabled":_vm.disabled},domProps:{"value":option.value,"checked":_vm.value === option.value},on:{"change":function($event){return _vm.$emit('input', option.value)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal",attrs:{"for":(_vm.name + "_" + (option.value))}},[_vm._v(_vm._s(option.label))])])}),0),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"text-danger small mt-1"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getForm: function getForm(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/biosecurity"));
  },
  createForm: function createForm(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/biosecurity"), data, {
      silent: true
    });
  },
  updateForm: function updateForm(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(draftId, "/biosecurity"), data, {
      silent: true
    });
  },
  getBlankPdf: function getBlankPdf() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/nominations/biosecurity-blank-form', {
      responseType: 'blob'
    });
  },
  downloadReport: function downloadReport(draftId, format) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/biosecurity/report"), {
      params: {
        format: format
      },
      responseType: 'blob'
    });
  }
});

/***/ }),

/***/ 1274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FText__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormFields_FTextarea__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FormFields_FRadioGroup__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FormFields_FCheckbox__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Biosecurity_BiosecurityHorseRow__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__composables_biosecurity_useBiosecurityForm__ = __webpack_require__(1431);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'BiosecurityForm',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_3__components_AppButton__["a" /* default */],
    FText: __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FText__["a" /* default */],
    FTextarea: __WEBPACK_IMPORTED_MODULE_5__components_FormFields_FTextarea__["a" /* default */],
    FRadioGroup: __WEBPACK_IMPORTED_MODULE_6__components_FormFields_FRadioGroup__["a" /* default */],
    FCheckbox: __WEBPACK_IMPORTED_MODULE_7__components_FormFields_FCheckbox__["a" /* default */],
    BiosecurityHorseRow: __WEBPACK_IMPORTED_MODULE_8__components_Biosecurity_BiosecurityHorseRow__["a" /* default */]
  },
  setup: function setup() {
    var vm = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])();
    var draftId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return vm.proxy.$route.params.draftId;
    });
    var horseKey = 2;
    var MOCK_MOVEMENT_TYPES = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([{
      value: 1,
      label: 'Movement From Cattle Tick Free Zone Into Cattle Tick Infected Zone'
    }, {
      value: 2,
      label: 'Movement Within Cattle Tick Free Zone'
    }, {
      value: 3,
      label: 'Movement From Cattle Tick Infected Zone Into Cattle Tick Free Zone'
    }, {
      value: 4,
      label: 'Movement Within Cattle Tick Infected Zone'
    }]);

    var _useBiosecurityForm = Object(__WEBPACK_IMPORTED_MODULE_9__composables_biosecurity_useBiosecurityForm__["a" /* default */])(draftId.value),
        isEdit = _useBiosecurityForm.isEdit,
        loading = _useBiosecurityForm.loading,
        submitting = _useBiosecurityForm.submitting,
        form = _useBiosecurityForm.form,
        errors = _useBiosecurityForm.errors,
        fetchForm = _useBiosecurityForm.fetchForm,
        submitForm = _useBiosecurityForm.submitForm,
        downloadBlankForm = _useBiosecurityForm.downloadBlankForm;

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      if (draftId.value) fetchForm();
    });

    function addHorse() {
      form.horses.push({
        _key: horseKey++,
        registeredName: '',
        breed: '',
        sex: '',
        identificationMarks: '',
        pic: ''
      });
    }

    function removeHorse(idx) {
      form.horses.splice(idx, 1);
    }

    function fieldError(key) {
      var errs = errors.value[key];
      return errs && errs.length > 0 ? errs[0] : null;
    }

    function onSubmit() {
      return _onSubmit.apply(this, arguments);
    }

    function _onSubmit() {
      _onSubmit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var success, from;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return submitForm();

              case 2:
                success = _context.sent;

                if (success) {
                  from = vm.proxy.$route.query.from;

                  if (from) {
                    vm.proxy.$router.push(from);
                  } else {
                    vm.proxy.$router.back();
                  }
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _onSubmit.apply(this, arguments);
    }

    return {
      isEdit: isEdit,
      loading: loading,
      submitting: submitting,
      form: form,
      errors: errors,
      MOCK_MOVEMENT_TYPES: MOCK_MOVEMENT_TYPES,
      addHorse: addHorse,
      removeHorse: removeHorse,
      onSubmit: onSubmit,
      downloadBlankForm: downloadBlankForm,
      fieldError: fieldError
    };
  }
}));

/***/ }),

/***/ 1275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppButton__ = __webpack_require__(92);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'BiosecurityHorseRow',
  components: {
    AppButton: __WEBPACK_IMPORTED_MODULE_1__components_AppButton__["a" /* default */]
  },
  props: {
    index: {
      type: Number,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['remove', 'input'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var row = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])({
      get: function get() {
        return props.value;
      },
      set: function set(val) {
        return emit('input', val);
      }
    });

    function fieldErr(field) {
      var key = "horses_data.".concat(props.index, ".").concat(field);
      var errs = props.errors[key];
      return errs && errs.length > 0 ? errs[0] : null;
    }

    return {
      row: row,
      fieldErr: fieldErr
    };
  }
}));

/***/ }),

/***/ 1427:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1428);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("69b5972e", content, true, {});

/***/ }),

/***/ 1428:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".biosecurity-form[data-v-4b29e7f2]{max-width:66.666%}.biosecurity-horses-table[data-v-4b29e7f2] td,.biosecurity-horses-table th[data-v-4b29e7f2]{font-size:1rem;vertical-align:middle}.biosecurity-horses-table[data-v-4b29e7f2] .form-control{font-size:1rem;padding:.375rem .75rem;height:auto}@media (max-width:768px){.biosecurity-form[data-v-4b29e7f2]{max-width:100%}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Biosecurity/BiosecurityForm.vue"],"names":[],"mappings":"AACA,mCACE,iBAAmB,CACpB,AACD,4FAEE,eAAgB,AAChB,qBAAuB,CACxB,AACD,yDACE,eAAgB,AAChB,uBAA0B,AAC1B,WAAa,CACd,AACD,yBACA,mCACI,cAAgB,CACnB,CACA","file":"BiosecurityForm.vue","sourcesContent":["\n.biosecurity-form[data-v-4b29e7f2] {\n  max-width: 66.666%;\n}\n.biosecurity-horses-table th[data-v-4b29e7f2],\n.biosecurity-horses-table[data-v-4b29e7f2] td {\n  font-size: 1rem;\n  vertical-align: middle;\n}\n.biosecurity-horses-table[data-v-4b29e7f2] .form-control {\n  font-size: 1rem;\n  padding: 0.375rem 0.75rem;\n  height: auto;\n}\n@media (max-width: 768px) {\n.biosecurity-form[data-v-4b29e7f2] {\n    max-width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BiosecurityHorseRow_vue__ = __webpack_require__(1275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660f2696_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BiosecurityHorseRow_vue__ = __webpack_require__(1430);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BiosecurityHorseRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660f2696_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BiosecurityHorseRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"align-middle text-center"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.row.registeredName),expression:"row.registeredName"}],class:['form-control form-control-sm', _vm.fieldErr('registered_name') && 'is-invalid'],attrs:{"type":"text"},domProps:{"value":(_vm.row.registeredName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.row, "registeredName", $event.target.value)}}}),_vm._v(" "),(_vm.fieldErr('registered_name'))?_c('div',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.fieldErr('registered_name')))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.row.breed),expression:"row.breed"}],class:['form-control form-control-sm', _vm.fieldErr('breed') && 'is-invalid'],attrs:{"type":"text"},domProps:{"value":(_vm.row.breed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.row, "breed", $event.target.value)}}}),_vm._v(" "),(_vm.fieldErr('breed'))?_c('div',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.fieldErr('breed')))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.row.sex),expression:"row.sex"}],class:['form-control form-control-sm', _vm.fieldErr('sex') && 'is-invalid'],attrs:{"type":"text"},domProps:{"value":(_vm.row.sex)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.row, "sex", $event.target.value)}}}),_vm._v(" "),(_vm.fieldErr('sex'))?_c('div',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.fieldErr('sex')))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.row.identificationMarks),expression:"row.identificationMarks"}],class:['form-control form-control-sm', _vm.fieldErr('identification_marks') && 'is-invalid'],attrs:{"type":"text"},domProps:{"value":(_vm.row.identificationMarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.row, "identificationMarks", $event.target.value)}}}),_vm._v(" "),(_vm.fieldErr('identification_marks'))?_c('div',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.fieldErr('identification_marks')))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.row.pic),expression:"row.pic"}],class:['form-control form-control-sm', _vm.fieldErr('pic') && 'is-invalid'],attrs:{"type":"text"},domProps:{"value":(_vm.row.pic)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.row, "pic", $event.target.value)}}}),_vm._v(" "),(_vm.fieldErr('pic'))?_c('div',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.fieldErr('pic')))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(_vm.removable)?_c('app-button',{attrs:{"variant":"outline-danger","size":"sm"},on:{"click":function($event){return _vm.$emit('remove')}}},[_vm._v("✕")]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useBiosecurityForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_biosecurity__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__composables_useScrollToError__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_EventBus__ = __webpack_require__(18);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





function useBiosecurityForm(draftId) {
  var isEdit = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var submitting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var errors = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({});
  Object(__WEBPACK_IMPORTED_MODULE_2__composables_useScrollToError__["a" /* default */])(errors);
  var form = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({
    namePersonInCharge: '',
    address: '',
    phone: '',
    email: '',
    propertyOfOrigin: '',
    destination: '',
    namePersonReceiving: '',
    pic: '',
    movementType: null,
    reasonNoTicks: '',
    signatureName: '',
    date: '',
    terms: false,
    horses: [{
      _key: 1,
      registeredName: '',
      breed: '',
      sex: '',
      identificationMarks: '',
      pic: ''
    }]
  });

  function fetchForm() {
    return _fetchForm.apply(this, arguments);
  }

  function _fetchForm() {
    _fetchForm = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res, data, b;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_biosecurity__["a" /* default */].getForm(draftId);

            case 4:
              res = _context.sent;
              data = res.data.data;

              if (data.exists && data.biosecurity) {
                isEdit.value = true;
                b = data.biosecurity;
                form.namePersonInCharge = b.name_person_in_charge != null ? b.name_person_in_charge : '';
                form.address = b.address != null ? b.address : '';
                form.phone = b.phone != null ? b.phone : '';
                form.email = b.email != null ? b.email : '';
                form.propertyOfOrigin = b.property_of_origin != null ? b.property_of_origin : '';
                form.destination = b.destination != null ? b.destination : '';
                form.namePersonReceiving = b.name_person_receiving != null ? b.name_person_receiving : '';
                form.pic = b.pic != null ? b.pic : '';
                form.movementType = b.movement_type;
                form.reasonNoTicks = b.reason_no_ticks != null ? b.reason_no_ticks : '';
                form.signatureName = b.name != null ? b.name : '';
                form.date = b.date != null ? b.date : '';

                if (b.horses_data != null && Array.isArray(b.horses_data)) {
                  form.horses = b.horses_data.map(function (h, i) {
                    return {
                      _key: i + 1,
                      registeredName: h.registered_name != null ? h.registered_name : '',
                      breed: h.breed != null ? h.breed : '',
                      sex: h.sex != null ? h.sex : '',
                      identificationMarks: h.identification_marks != null ? h.identification_marks : '',
                      pic: h.pic != null ? h.pic : ''
                    };
                  });
                }
              }

              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              isEdit.value = false;

            case 12:
              _context.prev = 12;
              loading.value = false;
              return _context.finish(12);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9, 12, 15]]);
    }));
    return _fetchForm.apply(this, arguments);
  }

  function buildPayload() {
    return {
      name_person_in_charge: form.namePersonInCharge,
      address: form.address,
      phone: form.phone,
      email: form.email,
      property_of_origin: form.propertyOfOrigin,
      destination: form.destination,
      name_person_receiving: form.namePersonReceiving,
      pic: form.pic,
      movement_type: form.movementType,
      reason_no_ticks: form.reasonNoTicks,
      name: form.signatureName,
      date: form.date,
      terms: form.terms,
      horses_data: form.horses.map(function (h) {
        return {
          registered_name: h.registeredName,
          breed: h.breed,
          sex: h.sex,
          identification_marks: h.identificationMarks,
          pic: h.pic
        };
      })
    };
  }

  function validate() {
    var e = {};

    function req(formKey, apiKey, label) {
      var val = form[formKey];
      if (val == null || val === '') e[apiKey] = ["The ".concat(label, " field is required.")];
    }

    req('phone', 'phone', 'phone number');
    req('email', 'email', 'email');
    req('propertyOfOrigin', 'property_of_origin', 'property of origin');
    req('destination', 'destination', 'destination');
    req('pic', 'pic', 'PIC number');
    if (form.movementType == null) e.movement_type = ['The movement type field is required.'];

    if (form.horses.length === 0 || form.horses.every(function (h) {
      return !h.registeredName;
    })) {
      e.horses_data = ['At least one horse with a registered name is required.'];
    }

    req('signatureName', 'name', 'name');
    req('date', 'date', 'date');
    if (!form.terms) e.terms = ['You must agree to the terms.'];
    return e;
  }

  function submitForm() {
    return _submitForm.apply(this, arguments);
  }

  function _submitForm() {
    _submitForm = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var clientErrors, payload, res, data, message;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              errors.value = {};
              clientErrors = validate();

              if (!(Object.keys(clientErrors).length > 0)) {
                _context2.next = 6;
                break;
              }

              errors.value = clientErrors;
              __WEBPACK_IMPORTED_MODULE_3__store_EventBus__["a" /* default */].$emit('http-error', 'Please fill in all required fields.');
              return _context2.abrupt("return", false);

            case 6:
              submitting.value = true;
              _context2.prev = 7;
              payload = buildPayload();

              if (!isEdit.value) {
                _context2.next = 15;
                break;
              }

              _context2.next = 12;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_biosecurity__["a" /* default */].updateForm(draftId, payload);

            case 12:
              _context2.t0 = _context2.sent;
              _context2.next = 18;
              break;

            case 15:
              _context2.next = 17;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_biosecurity__["a" /* default */].createForm(draftId, payload);

            case 17:
              _context2.t0 = _context2.sent;

            case 18:
              res = _context2.t0;
              if (res.data.message) __WEBPACK_IMPORTED_MODULE_3__store_EventBus__["a" /* default */].$emit('show-success', res.data.message);
              return _context2.abrupt("return", true);

            case 23:
              _context2.prev = 23;
              _context2.t1 = _context2["catch"](7);
              data = _context2.t1.response != null ? _context2.t1.response.data : null;

              if (data != null && data.code === 'validation_error') {
                errors.value = data.errors;
              }

              message = data != null && data.message ? data.message : 'A server error occurred. Please try again later.';
              __WEBPACK_IMPORTED_MODULE_3__store_EventBus__["a" /* default */].$emit('http-error', message);
              return _context2.abrupt("return", false);

            case 30:
              _context2.prev = 30;
              submitting.value = false;
              return _context2.finish(30);

            case 33:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[7, 23, 30, 33]]);
    }));
    return _submitForm.apply(this, arguments);
  }

  function downloadBlankForm() {
    return _downloadBlankForm.apply(this, arguments);
  }

  function _downloadBlankForm() {
    _downloadBlankForm = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      var res, blobUrl;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_biosecurity__["a" /* default */].getBlankPdf();

            case 3:
              res = _context3.sent;
              blobUrl = URL.createObjectURL(new Blob([res.data], {
                type: 'application/pdf'
              }));
              window.open(blobUrl, '_blank');
              _context3.next = 10;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 8]]);
    }));
    return _downloadBlankForm.apply(this, arguments);
  }

  return {
    isEdit: isEdit,
    loading: loading,
    submitting: submitting,
    form: form,
    errors: errors,
    fetchForm: fetchForm,
    submitForm: submitForm,
    downloadBlankForm: downloadBlankForm
  };
}

/***/ }),

/***/ 1432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"bg-white rounded mb-4 p-3",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('page-heading',[_vm._v(_vm._s(_vm.isEdit ? 'Edit' : 'Horse Movement / Horse Health Declaration'))]),_vm._v(" "),_c('form',{staticClass:"biosecurity-form",on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mb-3"},[_c('f-text',{attrs:{"id":"bio_name","label":"Name of person in charge of horses being travelled","error":_vm.fieldError('name_person_in_charge')},model:{value:(_vm.form.namePersonInCharge),callback:function ($$v) {_vm.$set(_vm.form, "namePersonInCharge", $$v)},expression:"form.namePersonInCharge"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3"},[_c('f-text',{attrs:{"id":"bio_address","label":"Address of person in charge","error":_vm.fieldError('address')},model:{value:(_vm.form.address),callback:function ($$v) {_vm.$set(_vm.form, "address", $$v)},expression:"form.address"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3"},[_c('f-text',{attrs:{"id":"bio_phone","label":"Phone Number","required":"","error":_vm.fieldError('phone'),"hint":"Please enter the phone in a similar format +614XXXXXXXXX without spaces","placeholder":"+614XXXXXXXXX"},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3"},[_c('f-text',{attrs:{"id":"bio_email","label":"Email","type":"email","required":"","error":_vm.fieldError('email')},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3"},[_c('f-text',{attrs:{"id":"bio_property","label":"Property of origin","required":"","error":_vm.fieldError('property_of_origin')},model:{value:(_vm.form.propertyOfOrigin),callback:function ($$v) {_vm.$set(_vm.form, "propertyOfOrigin", $$v)},expression:"form.propertyOfOrigin"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3"},[_c('f-text',{attrs:{"id":"bio_destination","label":"Destination","required":"","error":_vm.fieldError('destination')},model:{value:(_vm.form.destination),callback:function ($$v) {_vm.$set(_vm.form, "destination", $$v)},expression:"form.destination"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3"},[_c('f-text',{attrs:{"id":"bio_receiver","label":"Name of person receiving horses","error":_vm.fieldError('name_person_receiving')},model:{value:(_vm.form.namePersonReceiving),callback:function ($$v) {_vm.$set(_vm.form, "namePersonReceiving", $$v)},expression:"form.namePersonReceiving"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3"},[_c('f-text',{attrs:{"id":"bio_pic","label":"PIC Number","required":"","error":_vm.fieldError('pic')},model:{value:(_vm.form.pic),callback:function ($$v) {_vm.$set(_vm.form, "pic", $$v)},expression:"form.pic"}})],1)]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('f-radio-group',{attrs:{"name":"movementType","label":"What type of movement is this?","options":_vm.MOCK_MOVEMENT_TYPES,"required":"","error":_vm.fieldError('movement_type')},model:{value:(_vm.form.movementType),callback:function ($$v) {_vm.$set(_vm.form, "movementType", $$v)},expression:"form.movementType"}})],1),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('f-textarea',{attrs:{"id":"bio_ticks","label":"How did you ensure horse/s are tick free?","rows":3,"hint":"If This Movement is From Cattle Tick Infected Zone Into Cattle Tick Free Zone, please answer this question"},model:{value:(_vm.form.reasonNoTicks),callback:function ($$v) {_vm.$set(_vm.form, "reasonNoTicks", $$v)},expression:"form.reasonNoTicks"}})],1),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('h5',[_vm._v("Horses")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered biosecurity-horses-table"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"36px"}},[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Registered Name")]),_vm._v(" "),_c('th',[_vm._v("Breed")]),_vm._v(" "),_c('th',[_vm._v("Sex")]),_vm._v(" "),_c('th',[_vm._v("Identification marks")]),_vm._v(" "),_c('th',[_vm._v("PIC Number")]),_vm._v(" "),_c('th',{staticStyle:{"width":"36px"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.form.horses),function(horse,idx){return _c('biosecurity-horse-row',{key:horse._key,attrs:{"index":idx,"removable":idx > 0,"errors":_vm.errors},on:{"remove":function($event){return _vm.removeHorse(idx)}},model:{value:(_vm.form.horses[idx]),callback:function ($$v) {_vm.$set(_vm.form.horses, idx, $$v)},expression:"form.horses[idx]"}})}),1)])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end"},[_c('app-button',{attrs:{"variant":"primary","size":"sm","block":false},on:{"click":_vm.addHorse}},[_vm._v("\n            Add One More Horse\n          ")])],1)]),_vm._v(" "),_c('div',{staticClass:"mb-3 text-muted small"},[_c('p',[_vm._v("I declare that the horse/s named above has / have been in good health, eating normally and not shown signs of illness during the last five days leading up to this event. I give my authorisation for the Event Organising Committee/Biosecurity Manager to call for veterinary inspection of the horse/s named above and in my care should they be showing signs of illness at any time during the course of the event. I agree to pay any veterinary fees incurred for the abovementioned horses as a result of this veterinary examination. I agree that should my horse at any time become sick at the event I will advise the event organisers immediately.")]),_vm._v(" "),_c('p',[_vm._v("I AGREE TO ENSURE THAT: 1. All horses, vehicles and equipment accompanying horse/s will be clean and free of solid material (that could contain disease agents) prior to departing property of origin. I FURTHER DECLARE THAT: 2. The information contained in this Biosecurity Declaration is true and correct to the best of my knowledge. 3 I agree to abide and those people that are assisting me on the day, by all conditions that may be imposed at any time by the Event Organising Committee/Biosecurity Manager. 4. I acknowledge that in failure to comply, or those people that are assisting me on the day fail to comply, may be directed to leave the event and my nominations will be forfeited. 5. I acknowledge that decontamination and disinfection procedures may be required of me if instructed by the Event Organising Committee/Biosecurity Manager. 6. I acknowledge that there is a possibility that horses might become infected with disease agents as a result of any movements and if necessary horses and premises will be quarantined in accordance with any legislation covering such occurrences including policies and procedures in effect at that time. I agree and acknowledge that the Biosecurity Manager/Event Organising Committee, its State or National Affiliated bodies and their members are not in any way liable for any cost, expense, loss, damage, claim, action, proceeding or other liability incurred by or made against me as a result of any movement of horses to the event/farm.")])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12 col-md-6 mb-3 mb-md-0"},[_c('f-text',{attrs:{"id":"bio_signature","label":"Name","required":"","error":_vm.fieldError('name')},model:{value:(_vm.form.signatureName),callback:function ($$v) {_vm.$set(_vm.form, "signatureName", $$v)},expression:"form.signatureName"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3 mb-md-0"},[_c('f-text',{attrs:{"id":"bio_date","label":"Date","type":"date","required":"","error":_vm.fieldError('date')},model:{value:(_vm.form.date),callback:function ($$v) {_vm.$set(_vm.form, "date", $$v)},expression:"form.date"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('f-checkbox',{attrs:{"id":"bio_terms","label":"I agree to terms","font-normal":true,"required":"","error":_vm.fieldError('terms')},model:{value:(_vm.form.terms),callback:function ($$v) {_vm.$set(_vm.form, "terms", $$v)},expression:"form.terms"}})],1)]),_vm._v(" "),_c('app-button',{attrs:{"variant":"primary","size":"sm","block":false,"loading":_vm.submitting},on:{"click":_vm.onSubmit}},[_vm._v("Submit")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.54d377657b621dba7859.js